import React from 'react';
import { StyleSheet, Text, View, Linking, Pressable } from 'react-native';
import { Resource } from '../../../services/Resource';
import { ExelIcon, FileIcon, PdfIcon, PowerIcon, PowerPointIcon, WordIcon } from '../../Icons';
import { colors } from '../../Shared';

interface Props {
    resource: Resource;
    onPressToggle: (resource: Resource) => void;
}

export default function ResourceItem({ resource, onPressToggle }: Props) {
    const { name, positionName, fileName, uri, isActive } = resource;

    const RenderIconFile = () => {
        const [ext] = fileName?.split(".").reverse();
        if (ext === "pdf") {
            return <PdfIcon size={17} color="#ff0000" />;
        }

        if (ext === "docx" || ext === "dot" || ext === "dotx") {
            return <WordIcon size={17} color="#2b579a" />;
        }

        if (ext === "pot" || ext === "potm" || ext === "potx") {
            return <PowerPointIcon size={17} color="#d24726" />;
        }

        if (
            ext === "xla" ||
            ext === "xlam" ||
            ext === "xll" ||
            ext === "xlm" ||
            ext === "xls" ||
            ext === "xlsm" ||
            ext === "xlsx" ||
            ext === "xlt" ||
            ext === "xltm" ||
            ext === "xltx"
        ) {
            return <ExelIcon size={17} color="#217346" />;
        }

        return <FileIcon size={17} />;
    };

    const RenderFile = () => {
        return (
            <Pressable
                onPress={() => Linking.openURL(uri)}
                style={styles.renderFileContainer}
            >
                {RenderIconFile()}
                <Text style={{ color: "#000", marginLeft: 5 }}>{fileName.substring(0, 30)}</Text>
            </Pressable>
        );
    };

    return <View style={styles.container}>
        <View style={{ flexDirection: "column" }}>
            <Text style={{ textTransform: "capitalize", fontWeight: '300', fontSize: 16 }}>{name}</Text>
            <Text style={{ marginTop: 7,textTransform: "capitalize", fontWeight: '500', fontSize: 13}}>{positionName}</Text>
        </View>

        <View style={{ flex: 1 }} />
        {RenderFile()}

        <Pressable onPress={() => onPressToggle(resource)} style={{ paddingHorizontal: 15 }}>
            <PowerIcon color={isActive ? colors.bg.green : colors.bg.yellow} size={17} />
        </Pressable>
    </View>
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: colors.bg.light,
        margin: 5,
        borderRadius: 5,
        alignItems: 'center',
        padding: 10
    },
    renderFileContainer: {
        backgroundColor: "#00000020",
        height: '100%',
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        borderRadius: 10,
    },
});